import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  IVendorListsAggregationDTO,
  IVendorSearchFilterDTO,
  searchWithListAggregations,
} from 'wisestep-api';

const useAllvendorsSearch = (
  query: IVendorSearchFilterDTO,
  setLoader: Dispatch<SetStateAction<boolean>>
): IVendorListsAggregationDTO => {
  const [vendorsList, setVendorList] = useState<IVendorListsAggregationDTO>();

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        if (query) {
          setLoader(true);
          const response = await searchWithListAggregations(query);
          setLoader(false);
          const vendors = response.data;
          setVendorList(vendors);
        }
      } catch (e) {
        setLoader(false);
      }
    };

    fetchVendors();
  }, [query, setLoader]);
  return vendorsList ?? ({} as IVendorListsAggregationDTO);
};

export default useAllvendorsSearch;
